import * as Html from "../../util/Html.ts";
import Icons from "../../svg/Icons.ts";

Html.registerWidget('widget/specific/carrousel', { initDom, destroyDom })

interface CarouselElement extends HTMLElement {
  autoscrollInterval?: number;
}

function destroyDom(obj: CarouselElement) {
  if (obj.autoscrollInterval) {
    clearInterval(obj.autoscrollInterval);
    delete obj.autoscrollInterval;
  }
}

function initDom(obj: CarouselElement) {
  // Create navigation buttons
  const rightBtn = document.createElement('icon');
  rightBtn.className = 'picture-right';
  rightBtn.innerHTML = Icons.ic_chevron_right.string;
  obj.appendChild(rightBtn);

  const leftBtn = document.createElement('icon');
  leftBtn.className = 'picture-left';
  leftBtn.innerHTML = Icons.ic_chevron_left.string;
  obj.appendChild(leftBtn);

  const container = obj.firstElementChild as HTMLElement;
  const allImages = Array.from(container.children).filter(el => el.nodeType === 1) as HTMLElement[];
  const length = allImages.length;
  let idx = 0;

  // Check if element is in viewport relative to its scrollable container
  function isElementInView(element: HTMLElement, container: HTMLElement): boolean {
    const elementRect = element.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();

    return (
      elementRect.left >= containerRect.left &&
      elementRect.right <= containerRect.right
    );
  }

  // Custom scroll into view that respects container bounds
  function scrollIntoViewIfNeeded(element: HTMLElement) {
    // Only scroll if element is not already fully visible
    if (!isElementInView(element, container)) {
      // Use native scrollIntoView but keep it within the parent container
      element.scrollIntoView({
        block: "nearest",
        inline: "center",
        behavior: 'smooth'
      });
    }
  }

  function updateButtonVisibility() {
    // Show/hide navigation buttons based on position
    rightBtn.style.display = idx < length - 1 ? '' : 'none';
    leftBtn.style.display = idx > 0 ? '' : 'none';
  }

  function moveTo(targetIdx: number) {
    // Normalize index (handle negative and overflow values properly)
    if (targetIdx < 0) {
      idx = (targetIdx % length + length) % length;
    } else {
      idx = targetIdx % length;
    }

    scrollIntoViewIfNeeded(allImages[idx]);
    updateButtonVisibility();
  }

  // Initialize carousel
  moveTo(0);

  // Setup autoscroll
  function startAutoScroll() {
    obj.autoscrollInterval = window.setInterval(() => {
      moveTo(idx + 1);
    }, 4000);
  }

  function stopAutoScroll() {
    if (obj.autoscrollInterval) {
      clearInterval(obj.autoscrollInterval);
      delete obj.autoscrollInterval;
    }
  }

  startAutoScroll();

  // Navigation button handlers
  rightBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    e.preventDefault();
    stopAutoScroll();
    moveTo(idx + 1);
  });

  leftBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    e.preventDefault();
    stopAutoScroll();
    moveTo(idx - 1);
  });
}